import React, { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import Sidebar from "../sidebar/sidebar";
import { createData } from "../../hooks/api/utils";
import { get, post } from "../../hooks/services/service";
import { FaUpload } from "react-icons/fa";
import CreatableSelect from "react-select/creatable";

const AddIndustry = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    is_active: "true",
    image: null,
    vegetation_type: "",
    soil_type: "",
  });

  const [serviceOptions, setServiceOptions] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const res = await get("admin-panel/services-list/");
        if (res?.data) {
          const options = res.data?.data.map((service) => ({
            label: service.name,
            value: service.id,
          }));
          setServiceOptions(options);
        }
      } catch (err) {
        console.error("Failed to fetch services:", err);
      }
    };
    fetchServices();
  }, []);

  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.image) newErrors.image = "Image is required";
    return newErrors;
  };

  // const handleChange = (e) => {
  //   const { name, value, files, type } = e.target;
  //   setFormData((prev) => ({
  //     ...prev,
  //     [name]: type === "file" ? files[0] : value,
  //   }));
  //   setErrors({});
  // };

  const handleChange = (e) => {
    const { name, value, files, type } = e.target;
    if (type === "file") {
      const file = files[0];
      setFormData((prev) => ({
        ...prev,
        [name]: file,
      }));
      if (name === "image" && file) {
        setPreviewImage(URL.createObjectURL(file));
      }
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
    setErrors({});
  };

  const handleServiceChange = async (options) => {
    const updated = [];

    for (let option of options) {
      if (option.__isNew__) {
        try {
          const res = await post("admin-panel/services-list/", {
            name: option.label,
          });
          const newService = { label: res.data.name, value: res.data.id };
          updated.push(newService);

          // Also update global serviceOptions to include it
          setServiceOptions((prev) => [...prev, newService]);
        } catch (err) {
          console.error("Error creating service:", option.label, err);
        }
      } else {
        updated.push(option);
      }
    }

    setSelectedServices(updated);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const payload = new FormData();
    payload.append("name", formData.name.trim());
    payload.append("is_active", formData.is_active === "true");
    if (formData.image) payload.append("image", formData.image);

    payload.append(
      "vegetation_type",
      JSON.stringify(
        formData.vegetation_type
          .split(",")
          .map((v) => v.trim())
          .filter((v) => v)
      )
    );

    payload.append(
      "soil_type",
      JSON.stringify(
        formData.soil_type
          .split(",")
          .map((s) => s.trim())
          .filter((s) => s)
      )
    );

    selectedServices.forEach((service) => {
      payload.append("service", service.value);
    });

    setIsSubmitting(true);
    await createData(
      "/admin-panel/industries/",
      setIsSubmitting,
      payload,
      navigate,
      "/industry"
    );
  };

  return (
   
      <div className="rightContent">
        <div className="doc_info">
          <div className="row g-4">
            <div className="col-md-12">
              <div className="padding-inner border-radius-20 bg-white">
                <h4 className="mb-4">Add Industry</h4>

                {errors.api && (
                  <div className="alert alert-danger">{errors.api}</div>
                )}

                <form onSubmit={handleSubmit}>
                  <div className="row g-4">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>
                          Name<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          placeholder="Enter industry name"
                          className={`form-control ${
                            errors.name ? "is-invalid" : ""
                          }`}
                        />
                        {errors.name && (
                          <div className="invalid-feedback">{errors.name}</div>
                        )}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Status</label>
                        <select
                          name="is_active"
                          value={formData.is_active}
                          onChange={handleChange}
                          className="form-control"
                        >
                          <option value="true">Active</option>
                          <option value="false">Inactive</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Vegetation Type (comma-separated)</label>
                        <input
                          type="text"
                          name="vegetation_type"
                          value={formData.vegetation_type}
                          onChange={handleChange}
                          placeholder='e.g. "Wheat, Rice, Maize"'
                          className={`form-control ${
                            errors.vegetation_type ? "is-invalid" : ""
                          }`}
                        />
                        {errors.vegetation_type && (
                          <div className="invalid-feedback">
                            {errors.vegetation_type}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Soil Type (comma-separated)</label>
                        <input
                          type="text"
                          name="soil_type"
                          value={formData.soil_type}
                          onChange={handleChange}
                          placeholder='e.g. "Clay, Sandy, Loamy"'
                          className={`form-control ${
                            errors.soil_type ? "is-invalid" : ""
                          }`}
                        />
                        {errors.soil_type && (
                          <div className="invalid-feedback">
                            {errors.soil_type}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-md-12">
                      <div className="form-group">
                        <label>Services</label>
                        <CreatableSelect
                          isMulti
                          value={selectedServices}
                          onChange={handleServiceChange}
                          options={serviceOptions}
                          placeholder="Select or type to create services"
                          classNamePrefix="react-select"
                        />
                      </div>
                    </div>

                    <div className="col-md-12">
                      {/* <div className="form-group">
                        <label>
                          Add Picture<span className="text-danger">*</span>
                        </label>
                        <div className="custom-file-upload">
                          <input
                            type="file"
                            id="fileInput"
                            hidden
                            name="image"
                            onChange={handleChange}
                          />
                          <label htmlFor="fileInput" className="upload-box">
                            <span>
                              {formData.image ? formData.image.name : "Upload"}
                            </span>
                            <FaUpload className="upload-icon" />
                          </label>
                          {errors.image && (
                            <div className="text-danger">{errors.image}</div>
                          )}
                        </div>
                      </div> */}
                      <div className="form-group">
                        <label>
                          Add Picture<span className="text-danger">*</span>
                        </label>
                        <div className="custom-file-upload">
                          <input
                            type="file"
                            id="fileInput"
                            hidden
                            name="image"
                            onChange={handleChange}
                          />
                          <label htmlFor="fileInput" className="upload-box">
                            <span>
                              {formData.image ? formData.image.name : "Upload"}
                            </span>
                            <FaUpload className="upload-icon" />
                          </label>
                          {errors.image && (
                            <div className="text-danger">{errors.image}</div>
                          )}
                        </div>

                        {previewImage && (
  <div className="mt-3 position-relative" style={{ display: "inline-block" }}>
    <img
      src={previewImage}
      alt="Preview"
      style={{ width: "150px", height: "150px", borderRadius: "8px" }}
    />
    <button
      type="button"
      onClick={() => {
        setFormData((prev) => ({ ...prev, image: null }));
        setPreviewImage(null);
      }}
      style={{
        position: "absolute",
        top: "-10px",
        right: "-10px",
        background: "red",
        color: "#fff",
        border: "none",
        borderRadius: "50%",
        width: "24px",
        height: "24px",
        cursor: "pointer",
        fontWeight: "bold",
      }}
    >
      ×
    </button>
  </div>
)}
                      </div>
                    </div>

                    <div className="col-md-12">
                      <div className="d-flex gap-3 justify-content-end">
                        <NavLink
                          to={"/industry"}
                          type="button"
                          className="transparent_btn"
                        >
                          Cancel
                        </NavLink>
                        <button
                          type="submit"
                          className="blue_btn"
                          disabled={isSubmitting}
                        >
                          {isSubmitting ? "Submitting..." : "Add Industry"}
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
  
  );
};

export default AddIndustry;
